import { Component } from '@angular/core';

@Component({
  templateUrl: './account-migration-login.page.html',
})
/**
 * Account Migration Login Page!
 */
export class AccountMigrationLoginPage {}
